import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export const useMemberLookup = (q) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (q.trim().length < 3) { setList([]); return undefined; }
    const t = setTimeout(() => { api.get("/special-receipts/member-lookup", { params: { q } }).then((r) => setList(r.data)).catch(() => setList([])); }, 250);
    return () => clearTimeout(t);
  }, [q]);
  return list;
};

export const LookupInput = ({ value, onChange, onPick, testId, ...props }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemberLookup(q);
  const box = useRef(null);
  return (
    <div className="relative" ref={box} onBlur={(e) => { if (!box.current.contains(e.relatedTarget)) setOpen(false); }}>
      <Input value={value} onChange={(e) => { onChange(e.target.value); setQ(e.target.value); setOpen(true); }} autoComplete="off" data-testid={testId} {...props} />
      {open && list.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-auto rounded-md border bg-white shadow-lg" data-testid={`${testId}-suggestions`}>
          {list.map((m, i) => (
            <button type="button" key={`${m.pin}-${i}`} onClick={() => { onPick(m); setOpen(false); }} className="block w-full text-left px-3 py-2 hover:bg-[#FFF1F1] focus:bg-[#FFF1F1] outline-none" data-testid={`${testId}-option-${i}`}>
              <span className="block text-sm font-semibold">{m.name}</span>
              <span className="block text-xs text-gray-500 font-mono">{[m.pin, m.phone, m.email].filter(Boolean).join(" · ")}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
